export const experienceData = [
    {
        id: 1,
        company: 'Re-Banatex',
        jobtitle: 'Co-founder and COO',
        startYear: 'September 2022',
        endYear: 'Present'
    },
    {
        id: 2,
        company: 'KAZEABROAD',
        jobtitle: 'Web Developer',
        startYear: '2021',
        endYear: '2023'
    },
    {
        id: 3,
        company: 'Globiexplore',
        jobtitle: 'Co-founder, CTO',
        startYear: '2024',
        endYear: 'Present'
    },
]